export default __webpack_public_path__ + "static/media/icon.965a6a30.png";